<template>
    <DealsActionsModal  
        title="Perdemos" 
        type="lost"
        description="Não desanime!"
        @save="save"
        ref="lostModal"
    >
        <template slot="form">
            <DealsActionsReasonForm 
                type="lost"
                :multiselectLabel='__("Qual o motivo de perda?")'
                :multiselectPlaceholder='__("Digite ou selecione o motivo de perda")'
            />
        </template>
    </DealsActionsModal>
</template>


<script>
import DealsActionsReasonForm from '../ActionsReasonForm.vue';
import DealsActionsModal from '../../ActionsModal.vue';

export default {
    name: 'DealLostReasonModal',
    components: {
        DealsActionsReasonForm,
        DealsActionsModal
    },
    data() {
        return {
            card: {}
        }
    },

    methods: {
        handleOpen(card) {
            this.card = card;
            Bus.$emit('resetForm');
            this.$refs.lostModal.handleOpen();
        },
        
        save() {
            Bus.$emit('updateDealReason', this.card);
        }
    },
    mounted() {
        Bus.$on('openDealLostReasonModal', (card) => this.handleOpen(card));
    }
}
</script>

<style></style>
